import AutomationPostBanner from "../assets/media/banner-post-automacao.png";
import MarketAnalysisPostBanner from "../assets/media/banner-analise-mercadologica.png";
import PcpPostBanner from "../assets/media/banner-pcp.png";

const AUTOMATION_POST_SLUG = "como-identificar-se-um-processo-da-sua-empresa-pode-e-deve-ser-automatizado";
const MARKET_ANALYSIS_POST_SLUG = "analise-mercadologica-como-transformar-dados-em-decisoes-estrategicas-e-acelerar-resultados-com-rpa";
const PCP_POST_SLUG = "o-segredo-da-eficiencia-como-o-pcp-transforma-a-cadeia-produtiva-de-pequenas-industrias";

const BLOG_POSTS = [
    {
        slug: MARKET_ANALYSIS_POST_SLUG,
        url: `/blog/${MARKET_ANALYSIS_POST_SLUG}`,
        title: "Análise Mercadológica: como transformar dados em decisões estratégicas e acelerar resultados com RPA",
        seoTitle: "Análise mercadológica com RPA: dados para decisões estratégicas | Mango",
        description: "Entenda como a análise mercadológica transforma dados em decisões estratégicas e como o RPA acelera coleta, integração e atualização de informações.",
        excerpt: "Veja como unir análise mercadológica, automação RPA e inteligência de dados para monitorar mercado, concorrência e indicadores com mais velocidade.",
        category: "Inteligência de mercado",
        topic: "Análise mercadológica e RPA",
        dateLabel: "25 de junho de 2026",
        publishedAt: "2026-06-25",
        modifiedAt: "2026-06-25",
        readingTime: "Leitura de 8 min",
        image: MarketAnalysisPostBanner,
        imageAlt: "Painel digital de análise mercadológica com dados, gráficos e automação RPA",
        keywords: [
            "análise mercadológica",
            "RPA",
            "inteligência de mercado",
            "decisões estratégicas",
            "automação de dados"
        ]
    },
    {
        slug: AUTOMATION_POST_SLUG,
        url: `/blog/${AUTOMATION_POST_SLUG}`,
        title: "Como Identificar se um Processo da sua Empresa Pode (e Deve) Ser Automatizado",
        seoTitle: "Como identificar processos para automatizar com RPA | Mango",
        description: "Aprenda os 5 critérios para identificar processos que podem ser automatizados com RPA, reduzir erros operacionais e evitar automatizar gargalos mal estruturados.",
        excerpt: "Veja os sinais de que uma rotina operacional está pronta para RPA e entenda quando vale organizar o processo antes de investir em automação.",
        category: "Automação de processos",
        topic: "RPA e eficiência operacional",
        dateLabel: "24 de maio de 2026",
        publishedAt: "2026-05-24",
        modifiedAt: "2026-05-24",
        readingTime: "Leitura de 6 min",
        image: AutomationPostBanner,
        imageAlt: "Braço robótico interagindo com painéis digitais e fluxos de automação",
        keywords: [
            "automação de processos",
            "RPA",
            "processos automatizáveis",
            "eficiência operacional",
            "robôs de software"
        ]
    },
    {
        slug: PCP_POST_SLUG,
        url: `/blog/${PCP_POST_SLUG}`,
        title: "O Segredo da Eficiência: Como o PCP Transforma a Cadeia Produtiva de Pequenas Indústrias",
        seoTitle: "PCP para pequenas indústrias: como ganhar eficiência | Mango",
        description: "Entenda como o PCP organiza a cadeia produtiva de pequenas indústrias, reduz desperdícios, melhora prazos e apoia decisões com dados e tecnologia.",
        excerpt: "Entenda como o Planejamento e Controle da Produção tira pequenas indústrias do modo bombeiro e cria previsibilidade no chão de fábrica.",
        category: "Gestão industrial",
        topic: "PCP e cadeia produtiva",
        dateLabel: "22 de maio de 2026",
        publishedAt: "2026-05-22",
        modifiedAt: "2026-05-22",
        readingTime: "Leitura de 7 min",
        image: PcpPostBanner,
        imageAlt: "Operação industrial com painéis digitais de planejamento e controle da produção",
        keywords: [
            "PCP",
            "planejamento e controle da produção",
            "cadeia produtiva",
            "pequenas indústrias",
            "software para indústria"
        ]
    }
];

const FEATURED_POST = BLOG_POSTS[0];

function findPostBySlug(slug) {
    return BLOG_POSTS.find((post) => post.slug === slug);
}

export { AUTOMATION_POST_SLUG, MARKET_ANALYSIS_POST_SLUG, PCP_POST_SLUG, BLOG_POSTS, FEATURED_POST, findPostBySlug };
